import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initI18n } from './i18n';
import { registerServiceWorker } from './pwa';
import { startNetworkMonitor } from './services/networkMonitor';
import './index.css';

initI18n(import.meta.env.VITE_DEFAULT_LOCALE || 'en');
registerServiceWorker();
// Replays anything queued offline — on start, and on every reconnect (Rule 4).
startNetworkMonitor();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
